import React, { Component } from 'react';
import { Panel, Alert } from 'react-bootstrap';
import Loader from 'src/js/Loader.js';
import { Doughnut } from 'react-chartjs-2';
import { msgs } from 'src/js/ErrorMessage.js';
import 'src/css/Util.css'
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class ScoreChart extends Component {
  constructor() {
    super();

    this.createChartData = this.createChartData.bind(this);
  }

  // スコアチャートを作成
  createChartData() {
    const data = {
      datasets: [
        {
          data: [this.props.scoreData, 100-this.props.scoreData],
          backgroundColor: ["#E11F27","#1B1464"],
          borderWidth:1,
          datalabels: {
            display:false
          }
        }
      ],
      text: [this.props.scoreData != null ? this.props.scoreData :''],
      
    };
    return data;
  }

  render() {
    const {t} = this.props;
    const Error = () => (
      <div>
        {(() => {
          return (
            <Alert bsStyle="danger" className="alert-margin">
              <p>{t("Message." + msgs["msg_common_01"])}</p>
            </Alert>
          );
        })()}
      </div>
    );

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {enabled: false},
      hover: {mode: null},
      cutoutPercentage:60
    };

    return (
      <Panel>
        {
          // ローディング判定
          this.props.loading ? (
            <Loader />
          ) : // データ取得判定
          this.props.isData ? (
            <div className='chart-daughnut'>
              <div className='chart-number'><p className='doughnut-text'>{this.props.scoreData != null ? this.props.scoreData : ''}</p></div>
              <Doughnut data={this.createChartData} options={chartOptions} />
            </div>
          ) : (
            // 失敗
            <Error />
          )
        }
      </Panel>
    );
  }
}

export default withTranslation()(ScoreChart);



// WEBPACK FOOTER //
// ./src/component/Util/ScoreChart.js